import { MapPlaceSuggestionCustomFields } from 'types';
import Util from 'utilities/helper.util';

export const optimizeLabel = (
  label: string,
  customFields: MapPlaceSuggestionCustomFields
) => {
  const regionIndex = label.lastIndexOf(customFields.locality);
  const addressPart1 = label.substr(0, regionIndex);
  const addressPart2 = label.substr(regionIndex, label.length);
  let addressPart1Arr = addressPart1.split(' ');
  let addressPart2Arr = addressPart2.split(', ');
  addressPart1Arr = addressPart1Arr.map((l: string) => {
    return Util.toTitleCase(l);
  });
  addressPart2Arr = addressPart2Arr.map((l: string) => {
    return l === customFields.region ? l : Util.toTitleCase(l);
  });
  let newLabel = `${addressPart1Arr.join(' ')}${addressPart2Arr.join(' ')}`;
  newLabel = newLabel.replace('Australia', '');
  return newLabel.trim();
};
